import { useQuery } from 'react-query'
import { Account, QueryOptions } from '../../types'
import { logFactory } from '../../util/logFactory'
import { useAccountsService } from '../services'

interface UseAccountContext {
  account?: Account
  isError: boolean
  isLoading: boolean
}

const hookName = 'useAccount'
const log = logFactory(hookName)

const useAccount = (id: string, { enabled }: QueryOptions = { enabled: true }): UseAccountContext => {
  const { getAccounts, isReady } = useAccountsService()
  const params = { id }

  const fetchAccount = async (): Promise<Account> => {
    log(`🆔 Fetching account...`, params)

    const { data: accounts } = await getAccounts(params)
    const [found] = accounts

    log(`🆔 Found account`, found)

    return found
  }

  const {
    data: account,
    isError,
    isLoading,
  } = useQuery([hookName, params], fetchAccount, {
    enabled: Boolean(isReady && enabled && id),
  })

  return {
    account,
    isError,
    isLoading: (!isReady || isLoading) && !account,
  }
}

export { useAccount }
